import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const current = testimonials[active];

  return (
    <section className="bg-cream-dark py-24" id="testimonials">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-navy/10 text-navy text-xs font-semibold tracking-widest uppercase rounded-full mb-4">
            Member Success Stories
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-navy">
            Real Results from Real Investors
          </h2>
        </div>

        {/* Main Testimonial */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center mb-12">
          {/* Photo */}
          <div className="lg:col-span-2 flex justify-center lg:justify-start">
            <div className="relative">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-2xl overflow-hidden border-4 border-gold/30">
                <img
                  src={current.avatarUrl}
                  alt={current.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-gold rounded-xl px-5 py-3 text-navy-dark">
                <p className="font-bold text-lg font-playfair">{current.propertiesAcquired}</p>
                <p className="text-xs font-medium whitespace-nowrap">Properties Acquired</p>
              </div>
            </div>
          </div>

          {/* Quote */}
          <div className="lg:col-span-3 flex flex-col justify-center gap-6">
            <div className="text-gold text-7xl font-playfair leading-none select-none">&ldquo;</div>
            <blockquote className="font-playfair text-xl md:text-2xl text-navy leading-relaxed -mt-10">
              {current.quote}
            </blockquote>
            <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
              <div>
                <p className="font-bold text-navy text-lg">{current.name}</p>
                <p className="text-gray-500 text-sm">{current.role} · {current.location}</p>
              </div>
              <div className="ml-auto flex items-center gap-2 flex-shrink-0">
                <span className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                  current.tier === 'Elite'
                    ? 'bg-navy text-gold'
                    : 'bg-gold/20 text-gold-dark'
                }`}>
                  {current.tier} Member
                </span>
                <span className="text-gray-400 text-xs whitespace-nowrap">Since {current.memberSince}</span>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <span className="text-green-600 text-sm font-semibold flex items-center gap-1">
                <i className="ri-arrow-up-line" />
                {current.roi} Portfolio Growth
              </span>
            </div>
          </div>
        </div>

        {/* Navigation Dots + Thumbnails */}
        <div className="flex items-center gap-4 justify-center flex-wrap">
          {testimonials.map((t, idx) => (
            <button
              key={t.id}
              onClick={() => setActive(idx)}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg border transition-all duration-200 cursor-pointer ${
                idx === active
                  ? 'border-gold bg-gold/10'
                  : 'border-gray-200 hover:border-gold/50 bg-white'
              }`}
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatarUrl} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <span className={`text-xs font-medium whitespace-nowrap ${idx === active ? 'text-navy' : 'text-gray-500'}`}>
                {t.name.split(' ')[0]}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
